import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/contactoCanal`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const patchContactoCanal = async (itemId, body) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${itemId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  res = await parseJSON(res);

  return res.success;
};
